import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * Проверка, что ошибка — это FetchBaseQueryError (ошибка от fetchBaseQuery).
 */
export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
    return typeof error === 'object' && error != null && 'status' in error;
}

/**
 * Возвращает HTTP status code из ошибки RTK Query (после .unwrap()).
 * Для обычных HTTP-ошибок — число (400, 429, 500 и т.д.).
 * Для PARSING_ERROR — originalStatus, для остальных — undefined.
 */
export function getHttpStatus(error: unknown): number | undefined {
    if (!isFetchBaseQueryError(error)) return undefined;
    if (typeof error.status === 'number') return error.status;
    if (error.status === 'PARSING_ERROR' && 'originalStatus' in error) {
        return (error as { originalStatus?: number }).originalStatus;
    }
    return undefined;
}
